// React
import React from "react";

// Styles
import '../../assets/css/animations.css';

const Loader = () => {

    return (
        <div className={"loader"} id={'dusk'}>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
            <div className="line"></div>
        </div>
    );
};

export default Loader;



// WEBPACK FOOTER //
// ./src/Components/Loader/Loader.js